/* HCS (6 Jul 2026): global handler for cart-drawer "Complete your setup"
   add buttons. Lives here (not inline in the drawer snippet) because the
   drawer is re-rendered via the Section Rendering API and injected
   scripts never execute — this was why the FIRST add navigated away to
   the product page while later adds worked. Bound once on document. */
(function () {
  if (window.__hcsCrossSellBound) return;
  window.__hcsCrossSellBound = true;
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target && e.target.closest && e.target.closest('.hcs-cross-sell__form');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var btnLabel = btn ? btn.textContent : '';
      var isPairs = btn && btn.classList.contains('hcs-pairs__add');
      if (btn) {
        /* Optimistic: tick the instant it's tapped - the cart add + refresh
           continue in the background; reverts only if the add fails. */
        btn.disabled = true;
        if (isPairs) {
          btn.textContent = '\u2713';
          btn.classList.add('hcs-added');
        } else {
          btn.textContent = '\u2713 Added';
        }
      }
      var id = parseInt(form.querySelector('input[name="id"]').value, 10);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _hcs_upsell: '1' } }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          var sections = 'cart-drawer,cart-icon-bubble';
          if (document.querySelector('cart-items')) sections += ',main-cart-items,main-cart-footer';
          return fetch('/?sections=' + sections);
        })
        .then(function (r) {
          return r.json();
        })
        .then(function (sections) {
          if (sections['cart-icon-bubble']) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble) bubble.innerHTML = sections['cart-icon-bubble'];
          }
          if (sections['cart-drawer']) {
            var dom = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            var fresh = dom.querySelector('.drawer__inner');
            var current = document.querySelector('cart-drawer .drawer__inner, #CartDrawer .drawer__inner');
            if (fresh && current) current.replaceWith(fresh);
          }
          /* cart PAGE (/cart): refresh line items + totals in place */
          if (sections['main-cart-items']) {
            var domCI = new DOMParser().parseFromString(sections['main-cart-items'], 'text/html');
            var freshCI = domCI.querySelector('cart-items');
            var curCI = document.querySelector('cart-items');
            if (freshCI && curCI) curCI.replaceWith(freshCI);
          }
          if (sections['main-cart-footer']) {
            var domCF = new DOMParser().parseFromString(sections['main-cart-footer'], 'text/html');
            var freshCF = domCF.querySelector('.cart__footer');
            var curCF = document.querySelector('.cart__footer');
            if (freshCF && curCF) curCF.replaceWith(freshCF);
          }
          if (btn && document.contains(btn) && !isPairs) {
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = btnLabel || 'Add';
            }, 1200);
          }
        })
        .catch(function () {
          if (btn) {
            btn.disabled = false;
            btn.classList.remove('hcs-added');
            btn.textContent = 'Try again';
          }
        });
    },
    true
  );
})();
